import getContent from 'pp-react-l10n';
import React from 'react';
import { trackLinkClick } from '../fpti/fpti';
import { LINK_NAME } from '../fpti/fptiConstants';
import { isExternalFlow } from '../utility/externalIntegrationUtils';
import TemplateData from '../utility/getTemplateData';
import { isInContext, isMobileOrTablet } from '../utility/inContextDonation';
import classNames from 'classnames';

class CancelAndReturn extends React.Component {
  constructor() {
    super();
    this.state = {
      displayMe: TemplateData.charityCancelUrl ? true : false,
    };
    this.isLanding = TemplateData.viewName === 'landing';
  }

  handleCancel = () => {
    trackLinkClick(LINK_NAME.CANCEL);
    let cancelurl = TemplateData.charityCancelUrl;
    if (cancelurl.indexOf('http') != 0 && cancelurl.indexOf('//') != 0) {
      cancelurl = '//' + cancelurl;
    }
    window.location.href = cancelurl;
  };

  cancelButtonWrapperClass() {
    return classNames({
      'ppvx_col-sm-12': true,
      'text-center': true,
      pp_cancel_btn_wrapper: true,
      is_mobile: isMobileOrTablet(),
      is_landing: this.isLanding && !this.props.isGuest,
    });
  }

  render() {
    const getCancelAndReturnContent = getContent('locals')(
      'common/cancelAndReturn'
    );

    if (isExternalFlow() || isInContext()) {
      return null;
    }

    return (
      <div>
        {this.state.displayMe && (
          <div
            className={this.cancelButtonWrapperClass()}
            data-testid="cancel-and-return-container"
          >
            <a
              href="#"
              className="pp_cancel_btn"
              id="cancelReturnBtn"
              onClick={this.handleCancel}
            >
              {getCancelAndReturnContent('label.return', {
                orgName: TemplateData.donationName,
              })}
            </a>
          </div>
        )}
      </div>
    );
  }
}

export default CancelAndReturn;
